import { getExtensionValue } from '@medplum/core';
import type { Extension } from '@medplum/fhirtypes';

/**
 * Underscore-sibling primitives. In FHIR a primitive's id/extensions live on a
 * sibling `_<element>` object (e.g. `_valueString`) — `@medplum/fhirtypes` does
 * not type these, so this is the typed accessor. Extension extraction reuses
 * `@medplum/core`'s `getExtensionValue`; only the sibling lookup is ours.
 */

export const DATA_ABSENT_REASON =
  'http://hl7.org/fhir/StructureDefinition/data-absent-reason';

export type PrimitiveExtension = { id?: string; extension?: Extension[] };

export function getUnderscoreSibling(
  obj: object,
  elementKey: string,
): PrimitiveExtension | undefined {
  const sibling = (obj as Record<string, unknown>)[`_${elementKey}`];
  return sibling !== null && typeof sibling === 'object'
    ? (sibling as PrimitiveExtension)
    : undefined;
}

/** The `data-absent-reason` code carried on a primitive's underscore sibling, if any. */
export function getDataAbsentReason(
  sibling: PrimitiveExtension | undefined,
): string | undefined {
  if (!sibling) return undefined;
  const value = getExtensionValue(sibling, DATA_ABSENT_REASON);
  return typeof value === 'string' ? value : undefined;
}
